import 'bulma/css/bulma.min.css'
import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import './registerServiceWorker'
import './bogs_top'
import Toasted from 'vue-toasted'
import 'vue-googlemaps/dist/vue-googlemaps.css'
import VueGoogleMaps from 'vue-googlemaps'
import VueGeolocation from 'vue-browser-geolocation'
import VueMoment from 'vue-moment'
import VueClipboard from 'vue-clipboard2'
import VueTouch from 'vue-touch'

Vue.use(VueTouch, { name: 'v-touch' })
Vue.use(VueMoment)
Vue.use(VueClipboard)
Vue.use(VueGeolocation)
Vue.use(VueGoogleMaps, {
  load: {
    apiKey: 'AIzaSyDgq0jt2GElJDv6DqZfkJHeS3NhdXDrLi8', // AIzaSyCWgPKb_UZz55CISea99QwUMiikvAbN4Ms - origin
    libraries: ['places'],
    useBetaRenderer: false
  }
})
Vue.use(Toasted, {
  position: 'bottom-center',
  fullWidth: true,
  duration: 5000,
  singleton: true
})
Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
